// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__jc0_X","actionsCol":"EnrolledClinics_actionsCol__3vDPh"};